import { render, staticRenderFns } from "./BillTotal_map.vue?vue&type=template&id=245ccc62"
import script from "./BillTotal_map.vue?vue&type=script&lang=js"
export * from "./BillTotal_map.vue?vue&type=script&lang=js"
import style0 from "./BillTotal_map.vue?vue&type=style&index=0&id=245ccc62&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports